export function getText(appointment_templates) {
  return `(${appointment_templates.length})`
}
